import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-accessdenied',
    templateUrl: './app.accessdenied.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppAccessdeniedComponent {

}
